<template>
  <div class="index">
    <el-carousel indicator-position="outside">
      <el-carousel-item v-for="(item,index) in banner" :key="index">
        <img :src="$apiBaseUrl+item.ImgPath" >
      </el-carousel-item>
    </el-carousel>

    <div class="con_data">
      <div class="meCon">
        <div class="meLeft">
          <h2>精于品质 · 卓于服务</h2>
          <p>帮助企业健全设备信息化管理，它涵盖设备前期入库管理，设备台帐管理，设备状态和维护管理(含使用、点检)，故障诊断报警和维修管理、备件管理、设备后期的出库管理、物件审批流程管理、工单派发流程管理。
          总而言之，设备管理信息化是从管理思想、组织、方法和手段等全面的观点出发，运用信息化手段对设备的全寿命周期进行综合管理。</p>
          <p>实现整个建设中各功能模块的无缝对接，以及与上级ERP系统的数据对接，真正意义上的数据共享，互联互通，将数据充分利用。</p>
          <router-link to="/software" class="more">READ MORE</router-link>
        </div>
        <div class="meRight">
          <img :src="img_1" alt="" style="width:640px;height:430px">
        </div>
      </div>

      <div class="store-right">
        <div class="b">成功案例</div>
        <swiper  ref="mySwiper"
                 :options="swiperOption"
                 class="swiper-content swiper-container">
          <swiper-slide class="store-right-item" v-for="(item,index) in win" :key="index">
            <img :src="$apiBaseUrl+item.ImgPath" alt="">
          </swiper-slide>
        </swiper>
      </div>

      <div class="meCon">
        <div class="meLeft">
          <h1 class="blue">关于我们</h1>
          <p>河北八友台科技有限公司是一家以研发销售在线监测类产品及运行检修管理类软件为主的科技型中小企业，公司位于河北省石家庄市。自创立以来一直致力于为客户打造 “绿色”（节能降耗）的生产工艺以及“环保”（安全效率）的生产环境。公司的“设备物联智能化平台”通过设备在线监测系统，设备智能巡检系统，生产设备管理系统，智能语音通信融合系统，帮助客户更好的改进生产工艺，提高工作效率，争取更大的经济利益。也为公司管理层提供更好，更科学的管理依据。</p>
          <router-link to="/intro" class="more">READ MORE</router-link>
        </div>
        <div class="meRight">
          <img :src="img_2" alt="" style="width:640px;height:430px">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import baseURL from "../../../vue.config";
require('swiper/dist/css/swiper.css')

export default {
  name: 'c-carousel',
  components:{
    swiper,
    swiperSlide,
  },
  data() {
    return {
      img_1: require('../../assets/4.png'),
      img_2:require('../../assets/24.png'),
      swiperOption: {
        slidesPerView: '4',
        spaceBetween: 0,
        speed: 2000,
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        autoplay: {
          delay:1500,
          disableOnInteraction: false
        }
      },
      banner:[],
      win:[], //成功案例

    }
  },
  computed: {
    mySwiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  mounted() {
    this.getImage()
    this.getCarousel()
  },
  methods : {

    //获取轮播
    getCarousel(){
      let data={params:{ImgCate:1}}
      this.$axios.get('/api/Byt_Ent_Gateway/BytEntImgSelect',data).then(res=> {
        res = typeof res.data=='string'? JSON.parse(res.data):res.data;
        this.banner = res.data;
        console.log(res.data)
      })
    },
    //获取成功案例
    getImage(){
      let data={params:{ImgCate:2}}
      this.$axios.get('/api/Byt_Ent_Gateway/BytEntImgSelect',data).then(res=> {
        res = typeof res.data=='string'? JSON.parse(res.data):res.data;
        this.win = res.data;
      })
    },

  },


}
</script>

<style >
.meCon{
  clear: both;
  margin: 30px 0 50px;
  overflow: hidden;
}
.meLeft{
  float: left;
  width: 520px;
}
.meLeft p{
 line-height: 30px;
}
.meRight{
  float: right;
}
.b{
  width:60px;height: 180px;
  padding: 30px 20px;
  box-sizing: border-box;
  background-color:rgb(0, 106, 184);
  color: #fff;
  font-size: 20px;
  margin: 0 auto;
  line-height: 30px;
  font-weight: bold;
}
.store-right {
  clear: right;
  width: 100%;
  height: 200px;
  overflow: hidden;
  display: flex;
  justify-content: left;
}
.swiper-content{
  box-sizing: border-box;
  width: 1090px;
}
.store-right-item {
  margin-top: 5px;
  width: 260px;
  height: 172px;
  background-size: 100% 100%;
}
.el-carousel__container{
  height:450px !important;
  width: 100%;
  overflow: hidden !important;
}
.el-carousel__arrow{
  background-color: rgba(255,255,255,.6)  ;
}
.el-carousel--horizontal{
  overflow: visible !important;
}
.el-carousel__indicators{
  position: absolute;
}
</style>